import ManagerWorkspace from "../components/Workspace/ManagerWorkspace";

export default function Workspace() {
  return <ManagerWorkspace />;
}
